// 引入透明背景图片
const transparentBgUrl = require('@/assets/image/transparent.png');

/**
 * 调试日志弹窗工具构造函数
 * 用于在开发环境中显示对象的 key-value，支持图片预览
 * @param {Object} [options={}] - 配置选项
 * @param {boolean} [options.isPrintLog=true] - 是否同时打印到 console.log，默认为 true
 * @param {boolean} [options.isPrintStack=false] - 是否打印调用栈信息，默认为 false
 */
function DebugLog(options = {}) {
  // 存储 key 和图片尺寸的映射
  this.imageSizeMap = {};
  // 是否打印到控制台
  this.isPrintLog =
    options.isPrintLog !== undefined ? options.isPrintLog : true;
  // 是否打印调用栈
  this.isPrintStack =
    options.isPrintStack !== undefined ? options.isPrintStack : false;
}

/**
 * 调试日志方法
 * @param {Object} data - 要显示的对象
 */
DebugLog.prototype.log = function (data) {
  // 只在开发环境可用
  if (location.hostname == 'xingbaidesign.com') {
    return;
  }

  // 检查参数
  if (!data || typeof data !== 'object') {
    console.warn('debugLog: 参数必须是一个对象');
    return;
  }

  // 如果启用控制台打印，打印到 console.log
  if (this.isPrintLog) {
    const hasTitle = data && data.title !== undefined && data.title !== null;
    const timestamp = new Date().toLocaleTimeString();
    const titleText = hasTitle ? `${data.title}` : '';

    if (this.isPrintStack) {
      // 获取调用栈信息
      const stack = new Error().stack;
      const stackLines = stack.split('\n');
      // 跳过 Error 本身和当前函数，找到调用 debugLog 的位置
      // 通常第 3 行或第 4 行是调用位置
      let callSite = '';
      for (let i = 2; i < stackLines.length && i < 5; i++) {
        const line = stackLines[i];
        // 跳过内部函数调用
        if (
          line.indexOf('debugLog') === -1 &&
          line.indexOf('DebugLog') === -1
        ) {
          callSite = line.trim();
          break;
        }
      }

      if (callSite) {
        console.log(
          `\n[${timestamp}]${titleText ? ' ' + titleText : ''}`,
          data
        );
        console.log(`调用位置: ${callSite}`);
      } else {
        console.log(
          `\n[${timestamp}]${titleText ? ' ' + titleText : ''}`,
          data
        );
      }
    } else {
      if (hasTitle) {
        console.log(`[${timestamp}] ${data.title}`, data);
      } else {
        console.log(`[${timestamp}]`, data);
      }
    }
  }

  // 初始化调试面板（如果还没有创建）
  initDebugPanel.call(this);

  // 获取弹窗容器和内容容器
  const panel = document.querySelector('.debug-log-panel');
  const contentContainer = panel.querySelector('.debug-log-content');

  // 创建本次调用的内容区域
  const logEntry = document.createElement('div');
  logEntry.className = 'debug-log-entry';
  logEntry.style.cssText = `
    padding: 0.16rem;
    background: #fff;
  `;

  // 检查是否有 title，如果有则作为分组标题
  const hasTitle = data && data.title !== undefined && data.title !== null;
  let titleText = '';
  if (hasTitle) {
    titleText = String(data.title);
  }

  // 创建标题和时间戳的容器（并排显示）
  const headerContainer = document.createElement('div');
  headerContainer.style.cssText = `
    display: flex;
    align-items: center;
    gap: 0.12rem;
    margin-bottom: 0.12rem;
    padding-bottom: 0.08rem;
    border-bottom: ${hasTitle ? '2px solid #ff6b6b' : '1px dashed #eee'};
  `;

  // 添加时间戳
  const timestamp = document.createElement('div');
  timestamp.className = 'debug-log-timestamp';
  timestamp.textContent = new Date().toLocaleTimeString();
  timestamp.style.cssText = `
    font-size: 0.1rem;
    color: #999;
    flex-shrink: 0;
  `;
  headerContainer.appendChild(timestamp);

  // 添加标题（如果存在）
  if (hasTitle) {
    const titleDiv = document.createElement('div');
    titleDiv.className = 'debug-log-title-entry';
    titleDiv.textContent = titleText;
    titleDiv.style.cssText = `
      font-size: 0.14rem;
      font-weight: bold;
      color: #ff6b6b;
      flex: 1;
      cursor: pointer;
      user-select: none;
      transition: background 0.2s;
    `;
    // 点击复制标题
    titleDiv.onclick = function () {
      copyToClipboard(titleText, titleDiv);
    };
    // 鼠标悬停效果
    titleDiv.onmouseenter = function () {
      this.style.background = 'rgba(255, 107, 107, 0.1)';
    };
    titleDiv.onmouseleave = function () {
      this.style.background = '';
    };
    headerContainer.appendChild(titleDiv);
  }

  logEntry.appendChild(headerContainer);

  // 遍历对象的所有 key（排除 title）
  const keys = Object.keys(data).filter((key) => key !== 'title');
  if (keys.length === 0) {
    const emptyDiv = document.createElement('div');
    emptyDiv.textContent = hasTitle ? '无其他数据' : '对象为空';
    emptyDiv.style.cssText = `
      padding: 0.2rem;
      text-align: center;
      color: #999;
      font-size: 0.12rem;
    `;
    logEntry.appendChild(emptyDiv);
  } else {
    const self = this;
    keys.forEach((key) => {
      const value = data[key];
      const item = createLogItem.call(self, key, value);
      logEntry.appendChild(item);
    });
  }

  // 检查是否已有内容，如果有则添加分隔线
  const hasExistingContent = contentContainer.children.length > 0;
  if (hasExistingContent) {
    const separator = document.createElement('div');
    separator.className = 'debug-log-separator';
    separator.style.cssText = `
      height: 0.02rem;
      background: #ff6b6b;
      margin: 0.16rem 0;
      border-radius: 0.01rem;
    `;
    // 将新日志插入到顶部
    contentContainer.insertBefore(logEntry, contentContainer.firstChild);
    // 将分隔线插入到新日志之后
    contentContainer.insertBefore(separator, logEntry.nextSibling);
  } else {
    // 如果没有现有内容，直接追加
    contentContainer.appendChild(logEntry);
  }

  // 滚动到顶部（显示最新的日志）
  contentContainer.scrollTop = 0;
};

/**
 * 初始化调试面板（包括按钮和弹窗）
 */
function initDebugPanel() {
  // 如果已经初始化过，直接返回
  if (document.querySelector('.debug-log-toggle-btn')) {
    return;
  }

  // 创建切换按钮
  const toggleBtn = document.createElement('div');
  toggleBtn.className = 'debug-log-toggle-btn';
  toggleBtn.textContent = '调试';

  // 读取存储的按钮位置
  const savedPosition = localStorage.getItem('debugLogButtonPosition');
  let initialTop = 0;
  let initialRight = 0;
  let initialLeft = null;

  if (savedPosition) {
    try {
      const position = JSON.parse(savedPosition);
      if (position.top !== undefined) {
        initialTop = parseFloat(position.top) || 0;
      }
      if (position.right !== undefined && position.right !== null) {
        initialRight = parseFloat(position.right) || 0;
        initialLeft = null;
      } else if (position.left !== undefined && position.left !== null) {
        initialLeft = parseFloat(position.left) || 0;
        initialRight = null;
      }
    } catch (error) {
      console.warn('debugLog: 读取按钮位置失败', error);
    }
  }

  // 构建样式字符串
  let styleText = `
    position: fixed;
    top: ${initialTop}px;
    z-index: 10000;
    padding: 0.08rem 0.16rem;
    background: #ff6b6b;
    color: #fff;
    border-radius: 0.04rem;
    font-size: 0.12rem;
    cursor: pointer;
    user-select: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  `;

  if (initialLeft !== null) {
    styleText += `left: ${initialLeft}px;`;
  } else {
    styleText += `right: ${initialRight}px;`;
  }

  toggleBtn.style.cssText = styleText;

  // 创建弹窗
  const panel = createDebugPanel();

  // 读取存储的显示状态
  const savedState = localStorage.getItem('debugLogPanelVisible');
  const isVisible = savedState === 'true';

  // 设置初始显示状态
  if (isVisible) {
    panel.style.display = 'flex';
  } else {
    panel.style.display = 'none';
  }

  // 拖动相关变量
  let hasMoved = false;

  // 面板切换函数（提取为独立函数，供点击和触摸事件共用）
  function togglePanel() {
    const currentDisplay = panel.style.display;
    const newDisplay = currentDisplay === 'none' ? 'flex' : 'none';
    panel.style.display = newDisplay;
    // 保存状态到 localStorage
    localStorage.setItem(
      'debugLogPanelVisible',
      newDisplay === 'flex' ? 'true' : 'false'
    );
  }

  // 切换按钮点击事件（区分拖动和点击）
  toggleBtn.onclick = function (e) {
    // 如果发生了拖动，不触发点击事件
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
      hasMoved = false;
      return false;
    }

    togglePanel();
  };

  // 添加拖动功能
  setupDragHandlers(
    toggleBtn,
    function (moved) {
      hasMoved = moved;
    },
    togglePanel
  );

  // 添加到页面
  document.body.appendChild(toggleBtn);
  document.body.appendChild(panel);
}

/**
 * 设置按钮拖动处理
 * @param {HTMLElement} button - 按钮元素
 * @param {Function} onMoveCallback - 移动回调函数，参数为是否移动了
 * @param {Function} togglePanelCallback - 面板切换回调函数（用于移动端点击）
 */
function setupDragHandlers(button, onMoveCallback, togglePanelCallback) {
  let isDragging = false;
  let dragStartX = 0;
  let dragStartY = 0;
  let dragStartLeft = 0;
  let dragStartTop = 0;
  let hasMoved = false;
  // 移动阈值：移动端使用更大的阈值（10px），桌面端使用较小的阈值（5px）
  let moveThreshold = 'ontouchstart' in window ? 10 : 5;

  // 获取按钮当前位置（转换为像素值）
  function getButtonPosition() {
    const rect = button.getBoundingClientRect();
    const style = window.getComputedStyle(button);
    const top = parseFloat(style.top) || 0;
    const left = parseFloat(style.left) || 0;
    const right = parseFloat(style.right) || 0;

    // 如果设置了 right，计算 left
    let actualLeft = left;
    if (right !== 'auto' && parseFloat(right) >= 0) {
      actualLeft = window.innerWidth - rect.width - parseFloat(right);
    }

    return { top, left: actualLeft };
  }

  // 设置按钮位置
  function setButtonPosition(left, top) {
    // 获取按钮尺寸
    const rect = button.getBoundingClientRect();
    const buttonWidth = rect.width;
    const buttonHeight = rect.height;

    // 获取窗口尺寸
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    // 边界限制
    let finalLeft = left;
    let finalTop = top;

    // 限制在可视区域内
    if (finalLeft < 0) {
      finalLeft = 0;
    } else if (finalLeft + buttonWidth > windowWidth) {
      finalLeft = windowWidth - buttonWidth;
    }

    if (finalTop < 0) {
      finalTop = 0;
    } else if (finalTop + buttonHeight > windowHeight) {
      finalTop = windowHeight - buttonHeight;
    }

    // 设置位置，优先使用 left，如果靠近右边则使用 right
    const distanceToRight = windowWidth - finalLeft - buttonWidth;
    const distanceToLeft = finalLeft;

    if (distanceToRight < distanceToLeft) {
      // 更靠近右边，使用 right
      button.style.left = '';
      button.style.right = distanceToRight + 'px';
    } else {
      // 更靠近左边，使用 left
      button.style.right = '';
      button.style.left = finalLeft + 'px';
    }

    button.style.top = finalTop + 'px';

    return { left: finalLeft, top: finalTop, right: distanceToRight };
  }

  // 保存位置到 localStorage
  function savePosition() {
    const style = window.getComputedStyle(button);
    const top = parseFloat(style.top) || 0;
    const left = parseFloat(style.left) || 0;
    const right = parseFloat(style.right) || 0;

    const position = {
      top: top
    };

    if (style.right !== 'auto' && right >= 0) {
      position.right = right;
      position.left = null;
    } else if (style.left !== 'auto' && left >= 0) {
      position.left = left;
      position.right = null;
    }

    try {
      localStorage.setItem('debugLogButtonPosition', JSON.stringify(position));
    } catch (error) {
      console.warn('debugLog: 保存按钮位置失败', error);
    }
  }

  // 获取事件坐标
  function getEventCoordinates(e) {
    if (e.touches && e.touches.length > 0) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
    return { x: e.clientX, y: e.clientY };
  }

  // 鼠标按下 / 触摸开始
  function handleStart(e) {
    isDragging = true;
    hasMoved = false;
    const coords = getEventCoordinates(e);
    dragStartX = coords.x;
    dragStartY = coords.y;

    const pos = getButtonPosition();
    dragStartLeft = pos.left;
    dragStartTop = pos.top;

    button.style.cursor = 'move';
    button.style.transition = 'none';

    if (onMoveCallback) {
      onMoveCallback(false);
    }

    // 阻止默认行为，防止页面滚动（触摸事件）或文本选择（鼠标事件）
    // 对于触摸事件，即使只是点击，也需要阻止默认行为来防止页面滚动
    // 点击逻辑会在 touchend 时手动处理
    e.preventDefault();
  }

  // 鼠标移动 / 触摸移动
  function handleMove(e) {
    if (!isDragging) {
      return;
    }

    const coords = getEventCoordinates(e);
    const deltaX = coords.x - dragStartX;
    const deltaY = coords.y - dragStartY;

    // 计算移动距离
    const moveDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    if (moveDistance > moveThreshold) {
      hasMoved = true;
      if (onMoveCallback) {
        onMoveCallback(true);
      }
    }

    // 计算新位置
    const newLeft = dragStartLeft + deltaX;
    const newTop = dragStartTop + deltaY;

    setButtonPosition(newLeft, newTop);

    e.preventDefault();
  }

  // 鼠标抬起 / 触摸结束
  function handleEnd(e) {
    if (!isDragging) {
      return;
    }

    const wasMoved = hasMoved;
    // 判断是否为触摸事件：检查事件类型是否为 touchend
    const isTouchEvent = e.type === 'touchend';
    isDragging = false;
    button.style.cursor = 'pointer';
    button.style.transition = '';

    // 保存位置
    if (wasMoved) {
      savePosition();
    }

    // 移动端触摸点击处理：如果没有拖动，触发面板切换
    if (isTouchEvent && !wasMoved && togglePanelCallback) {
      // 延迟执行，确保拖动状态已重置，避免与点击事件冲突
      setTimeout(function () {
        togglePanelCallback();
      }, 10);
    }

    // 只在真正发生拖动时才阻止默认行为
    // 对于触摸事件，如果没有拖动，不阻止默认行为，允许后续点击事件触发
    if (wasMoved) {
      e.preventDefault();
    } else if (!isTouchEvent) {
      // 桌面端鼠标事件，始终阻止默认行为
      e.preventDefault();
    }

    // 延迟重置 hasMoved，确保点击事件能正确判断
    // 使用 setTimeout 确保在点击事件之后才重置
    setTimeout(function () {
      if (onMoveCallback) {
        onMoveCallback(false);
      }
      hasMoved = false;
    }, 0);
  }

  // 绑定鼠标事件
  button.addEventListener('mousedown', handleStart);
  document.addEventListener('mousemove', handleMove);
  document.addEventListener('mouseup', handleEnd);

  // 绑定触摸事件
  button.addEventListener('touchstart', handleStart, { passive: false });
  document.addEventListener('touchmove', handleMove, { passive: false });
  document.addEventListener('touchend', handleEnd);
}

/**
 * 创建调试弹窗 DOM 结构
 */
function createDebugPanel() {
  // 创建主容器
  const panel = document.createElement('div');
  panel.className = 'debug-log-panel';
  panel.style.cssText = `
    position: fixed;
    top: 0.6rem;
    right: 0.2rem;
    z-index: 9999;
    width: 3.5rem;
    max-height: 80vh;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 0.08rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    display: none;
    flex-direction: column;
    overflow: hidden;
  `;

  // 创建头部（包含标题和关闭按钮）
  const header = document.createElement('div');
  header.className = 'debug-log-header';
  header.style.cssText = `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.12rem 0.16rem;
    background: #ff6b6b;
    color: #fff;
    border-radius: 0.08rem 0.08rem 0 0;
  `;

  const title = document.createElement('div');
  title.className = 'debug-log-title';
  title.textContent = '调试日志';
  title.style.cssText = `
    font-size: 0.14rem;
    font-weight: bold;
  `;

  // 创建按钮容器
  const btnContainer = document.createElement('div');
  btnContainer.style.cssText = `
    display: flex;
    align-items: center;
    gap: 0.08rem;
  `;

  // 清空按钮
  const clearBtn = document.createElement('div');
  clearBtn.className = 'debug-log-clear';
  clearBtn.textContent = '清空';
  clearBtn.style.cssText = `
    padding: 0.04rem 0.08rem;
    font-size: 0.11rem;
    cursor: pointer;
    user-select: none;
    border-radius: 0.04rem;
    background: rgba(255, 255, 255, 0.2);
    transition: background 0.2s;
    margin-right:.15rem;
  `;

  // 清空按钮点击事件
  const self = this;
  clearBtn.onclick = function () {
    const contentContainer = panel.querySelector('.debug-log-content');
    if (contentContainer) {
      contentContainer.innerHTML = '';
    }
    // 清空图片尺寸映射
    Object.keys(self.imageSizeMap).forEach((key) => {
      delete self.imageSizeMap[key];
    });
    // 关闭弹窗
    panel.style.display = 'none';
    // 保存状态到 localStorage
    localStorage.setItem('debugLogPanelVisible', 'false');
  };

  // 清空按钮鼠标悬停效果
  clearBtn.onmouseenter = function () {
    this.style.background = 'rgba(255, 255, 255, 0.3)';
  };
  clearBtn.onmouseleave = function () {
    this.style.background = 'rgba(255, 255, 255, 0.2)';
  };

  const closeBtn = document.createElement('div');
  closeBtn.className = 'debug-log-close';
  closeBtn.textContent = '×';
  closeBtn.style.cssText = `
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    text-align: center;
    font-size: 0.2rem;
    cursor: pointer;
    user-select: none;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    transition: background 0.2s;
  `;

  // 关闭按钮点击事件
  closeBtn.onclick = function () {
    panel.style.display = 'none';
    // 保存状态到 localStorage
    localStorage.setItem('debugLogPanelVisible', 'false');
  };

  // 关闭按钮鼠标悬停效果
  closeBtn.onmouseenter = function () {
    this.style.background = 'rgba(255, 255, 255, 0.3)';
  };
  closeBtn.onmouseleave = function () {
    this.style.background = 'rgba(255, 255, 255, 0.2)';
  };

  btnContainer.appendChild(clearBtn);
  btnContainer.appendChild(closeBtn);
  header.appendChild(title);
  header.appendChild(btnContainer);
  panel.appendChild(header);

  // 创建内容容器（可滚动）
  const contentContainer = document.createElement('div');
  contentContainer.className = 'debug-log-content';
  contentContainer.style.cssText = `
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(80vh - 0.48rem);
  `;
  panel.appendChild(contentContainer);

  return panel;
}

/**
 * 创建单个日志项
 * @param {string} key - 对象的 key
 * @param {*} value - 对象的 value
 */
function createLogItem(key, value) {
  const item = document.createElement('div');
  item.className = 'debug-log-item';
  item.style.cssText = `
    margin-bottom: 0.16rem;
    padding: 0.12rem;
    background: #f8f9fa;
    border-radius: 0.04rem;
    border-left: 3px solid #ff6b6b;
  `;

  // 判断是否为图片
  const isImage = isImageUrl(value);

  if (isImage) {
    // 图片显示
    const imageContainer = document.createElement('div');
    imageContainer.style.cssText = `
      display: flex;
      flex-direction: column;
      gap: 0.08rem;
    `;

    // Key 标签和按钮容器
    const keyContainer = document.createElement('div');
    keyContainer.style.cssText = `
      display: flex;
      align-items: center;
      gap: 0.08rem;
      margin-bottom: 0.08rem;
    `;

    // Key 标签（包含图片尺寸信息）
    const keyLabel = document.createElement('div');
    keyLabel.className = 'debug-log-image-key';
    keyLabel.textContent = key;
    // 保存原始 key 值到 data 属性，用于复制
    keyLabel.setAttribute('data-original-key', key);
    keyLabel.style.cssText = `
      font-size: 0.12rem;
      font-weight: bold;
      color: #ff6b6b;
      padding: 0.04rem 0.08rem;
      background: #fff;
      border-radius: 0.04rem;
      display: inline-block;
      flex: 1;
      cursor: pointer;
      user-select: none;
      transition: background 0.2s;
    `;
    // 点击复制原始 key
    keyLabel.onclick = function () {
      const originalKey = this.getAttribute('data-original-key') || key;
      copyToClipboard(originalKey, keyLabel);
    };
    // 鼠标悬停效果
    keyLabel.onmouseenter = function () {
      this.style.background = 'rgba(255, 107, 107, 0.1)';
    };
    keyLabel.onmouseleave = function () {
      this.style.background = '#fff';
    };

    // 下载按钮
    const downloadBtn = document.createElement('div');
    downloadBtn.className = 'debug-log-download-image';
    downloadBtn.textContent = '下载';
    downloadBtn.style.cssText = `
      padding: 0.04rem 0.08rem;
      font-size: 0.11rem;
      cursor: pointer;
      user-select: none;
      border-radius: 0.04rem;
      background: #2196f3;
      color: #fff;
      transition: background 0.2s;
      flex-shrink: 0;
    `;

    // 下载按钮点击事件
    downloadBtn.onclick = function () {
      downloadImage(value, key, downloadBtn);
    };

    // 下载按钮鼠标悬停效果
    downloadBtn.onmouseenter = function () {
      this.style.background = '#1976d2';
    };
    downloadBtn.onmouseleave = function () {
      this.style.background = '#2196f3';
    };

    keyContainer.appendChild(keyLabel);
    keyContainer.appendChild(downloadBtn);

    // 图片包装容器（用于显示透明背景和居中）
    const imgWrapper = document.createElement('div');
    imgWrapper.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 3rem;
      min-height: 3rem;
      max-width: 3rem;
      max-height: 3rem;
      padding: 0.08rem;
      box-sizing: border-box;
    `;

    // 图片容器（用于显示透明背景）
    const imgContainer = document.createElement('div');
    imgContainer.style.cssText = `
      position: relative;
      border: 1px solid #ddd;
      border-radius: 0.04rem;
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 100%;
      max-height: 100%;
      overflow: hidden;
    `;

    // 透明背景图片（平铺）
    const bgImg = document.createElement('img');
    bgImg.src = transparentBgUrl;
    bgImg.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: repeat;
      pointer-events: none;
      z-index: 0;
    `;

    // 图片元素
    const img = document.createElement('img');
    img.src = value;
    img.style.cssText = `
      position: relative;
      z-index: 1;
      max-width: 2.84rem;
      max-height: 2.84rem;
      width: auto;
      height: auto;
      display: block;
      object-fit: contain;
    `;

    // 加载状态
    const loadingDiv = document.createElement('div');
    loadingDiv.className = 'debug-log-image-loading';
    loadingDiv.textContent = '加载中...';
    loadingDiv.style.cssText = `
      padding: 0.1rem;
      text-align: center;
      color: #666;
      font-size: 0.11rem;
      background: #f0f0f0;
      border-radius: 0.04rem;
      display: block;
    `;

    // 图片加载完成事件
    const debugLogInstance = this;
    img.onload = function () {
      loadingDiv.style.display = 'none';
      const width = this.naturalWidth;
      const height = this.naturalHeight;
      // 获取图片格式
      getImageFormat(value, function (format) {
        // 更新 key 标签，显示图片尺寸和格式
        const formatText = format ? ` ${format}` : '';
        keyLabel.textContent = `${key} (${width}×${height}${formatText})`;
        // 存储到映射中，以便后续更新
        debugLogInstance.imageSizeMap[key] = { width, height, format };
      });
    };

    // 图片加载失败事件
    img.onerror = function () {
      loadingDiv.textContent = '图片加载失败';
      loadingDiv.style.cssText = `
        padding: 0.1rem;
        text-align: center;
        color: #f44336;
        font-size: 0.11rem;
        background: #ffebee;
        border-radius: 0.04rem;
        display: block;
      `;
    };

    // 如果之前已经加载过这个图片，直接显示尺寸和格式
    if (this.imageSizeMap[key]) {
      const sizeInfo = this.imageSizeMap[key];
      const formatText = sizeInfo.format ? ` ${sizeInfo.format}` : '';
      keyLabel.textContent = `${key} (${sizeInfo.width}×${sizeInfo.height}${formatText})`;
    }

    imageContainer.appendChild(keyContainer);
    imgContainer.appendChild(bgImg);
    imgContainer.appendChild(img);
    imgWrapper.appendChild(imgContainer);
    imageContainer.appendChild(imgWrapper);
    imageContainer.appendChild(loadingDiv);
    item.appendChild(imageContainer);
  } else {
    // 普通文本显示
    const keyDiv = document.createElement('div');
    keyDiv.className = 'debug-log-key';
    keyDiv.textContent = key;
    keyDiv.style.cssText = `
      font-size: 0.12rem;
      font-weight: bold;
      color: #333;
      margin-bottom: 0.08rem;
      cursor: pointer;
      user-select: none;
      transition: background 0.2s;
    `;
    // 点击复制 key
    keyDiv.onclick = function () {
      copyToClipboard(key, keyDiv);
    };
    // 鼠标悬停效果
    keyDiv.onmouseenter = function () {
      this.style.background = 'rgba(0, 0, 0, 0.05)';
    };
    keyDiv.onmouseleave = function () {
      this.style.background = '';
    };

    const valueDiv = document.createElement('div');
    valueDiv.className = 'debug-log-value';

    // 处理不同类型的值
    let displayValue = value;
    if (value === null) {
      displayValue = 'null';
    } else if (value === undefined) {
      displayValue = 'undefined';
    } else if (typeof value === 'object') {
      try {
        displayValue = JSON.stringify(value, null, 2);
      } catch (error) {
        displayValue = String(value);
      }
    } else {
      displayValue = String(value);
    }

    valueDiv.textContent = displayValue;
    valueDiv.style.cssText = `
      font-size: 0.11rem;
      color: #666;
      word-break: break-all;
      font-family: monospace;
      background: #fff;
      padding: 0.08rem;
      border-radius: 0.04rem;
      white-space: pre-wrap;
      max-height: 2rem;
      overflow-y: auto;
    `;

    item.appendChild(keyDiv);
    item.appendChild(valueDiv);
  }

  return item;
}

/**
 * 判断值是否为图片 URL
 * @param {*} value - 要判断的值
 * @returns {boolean} 是否为图片 URL
 */
function isImageUrl(value) {
  if (typeof value !== 'string') {
    return false;
  }

  // 检测 blob URL
  if (value.indexOf('blob:') === 0) {
    return true;
  }

  // 检测网络图片
  if (value.indexOf('http://') === 0 || value.indexOf('https://') === 0) {
    return true;
  }

  // 检测 base64 图片
  if (value.indexOf('data:image/') === 0) {
    return true;
  }

  return false;
}

/**
 * 获取图片格式
 * @param {string} imageUrl - 图片 URL
 * @param {Function} callback - 回调函数，参数为格式字符串（如 'png', 'jpg'）
 */
function getImageFormat(imageUrl, callback) {
  if (!imageUrl || typeof imageUrl !== 'string') {
    callback('');
    return;
  }

  // base64 图片：从 data URI 中提取格式
  if (imageUrl.indexOf('data:image/') === 0) {
    const match = imageUrl.match(/data:image\/(\w+);/);
    if (match && match[1]) {
      callback(match[1].toUpperCase());
      return;
    }
  }

  // blob URL：需要异步获取 blob 类型
  if (imageUrl.indexOf('blob:') === 0) {
    (async function () {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const type = blob.type;
        if (type && type.indexOf('image/') === 0) {
          const format = type.split('/')[1].toUpperCase();
          callback(format);
        } else {
          callback('');
        }
      } catch (error) {
        callback('');
      }
    })();
    return;
  }

  // 网络图片：从 URL 扩展名获取
  if (imageUrl.indexOf('http://') === 0 || imageUrl.indexOf('https://') === 0) {
    try {
      const url = new URL(imageUrl);
      const pathname = url.pathname;
      const match = pathname.match(/\.(\w+)(\?|$)/);
      if (match && match[1]) {
        const ext = match[1].toLowerCase();
        // 统一格式名称
        const formatMap = {
          jpg: 'JPG',
          jpeg: 'JPG',
          png: 'PNG',
          gif: 'GIF',
          webp: 'WEBP',
          svg: 'SVG',
          bmp: 'BMP'
        };
        callback(formatMap[ext] || ext.toUpperCase());
        return;
      }
    } catch (error) {
      // URL 解析失败
    }
  }

  callback('');
}

/**
 * 下载图片
 * @param {string} imageUrl - 图片 URL（base64、blob URL 或网络图片）
 * @param {string} key - 图片的 key，用作文件名
 * @param {HTMLElement} button - 下载按钮元素，用于显示状态
 */
function downloadImage(imageUrl, key, button) {
  const originalText = button.textContent;
  button.textContent = '下载中...';
  button.style.background = '#999';
  button.style.cursor = 'not-allowed';

  // 将图片转换为 blob URL 或直接使用
  convertImageToBlobUrlForDownload(imageUrl)
    .then(function (blobUrl) {
      try {
        // 创建下载链接
        const link = document.createElement('a');
        link.href = blobUrl;
        // 使用 key 作为文件名，如果没有 key 则使用时间戳
        const fileName = key || 'image';
        link.download = fileName + '.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 如果是 blob URL，下载后释放
        if (blobUrl.indexOf('blob:') === 0) {
          setTimeout(function () {
            URL.revokeObjectURL(blobUrl);
          }, 100);
        }

        button.textContent = '已下载';
        button.style.background = '#4caf50';
        setTimeout(function () {
          button.textContent = originalText;
          button.style.background = '#2196f3';
          button.style.cursor = 'pointer';
        }, 2000);
      } catch (error) {
        console.error('下载图片失败:', error);
        button.textContent = '下载失败';
        button.style.background = '#f44336';
        setTimeout(function () {
          button.textContent = originalText;
          button.style.background = '#2196f3';
          button.style.cursor = 'pointer';
        }, 2000);
      }
    })
    .catch(function (error) {
      console.error('下载图片失败:', error);
      button.textContent = '下载失败';
      button.style.background = '#f44336';
      setTimeout(function () {
        button.textContent = originalText;
        button.style.background = '#2196f3';
        button.style.cursor = 'pointer';
      }, 2000);
    });
}

/**
 * 将图片转换为 blob URL（用于下载）
 * @param {string} imageUrl - 图片 URL
 * @returns {Promise<string>} blob URL
 */
function convertImageToBlobUrlForDownload(imageUrl) {
  return new Promise(function (resolve, reject) {
    // 如果已经是 blob URL，直接返回
    if (imageUrl.indexOf('blob:') === 0) {
      resolve(imageUrl);
      return;
    }

    // 如果已经是 base64，转换为 blob URL
    if (imageUrl.indexOf('data:image/') === 0) {
      try {
        // 分离 MIME 类型和 base64 数据
        const parts = imageUrl.split(',');
        const mimeMatch = parts[0].match(/:(.*?);/);
        const contentType =
          mimeMatch && mimeMatch[1] ? mimeMatch[1] : 'image/png';
        const base64Data = parts[1];

        // 解码 base64
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const blobUrl = URL.createObjectURL(blob);
        resolve(blobUrl);
      } catch (error) {
        reject(error);
      }
      return;
    }

    // 网络图片：先加载，再转换为 blob URL
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = function () {
      try {
        // 创建 canvas
        const canvas = document.createElement('canvas');
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;
        const ctx = canvas.getContext('2d');

        // 绘制图片到 canvas
        ctx.drawImage(this, 0, 0);

        // 转换为 blob
        canvas.toBlob(
          function (blob) {
            if (blob) {
              const blobUrl = URL.createObjectURL(blob);
              resolve(blobUrl);
            } else {
              reject(new Error('canvas 转换为 blob 失败'));
            }
          },
          'image/png',
          1
        );
      } catch (error) {
        reject(error);
      }
    };

    img.onerror = function () {
      reject(new Error('图片加载失败'));
    };

    img.src = imageUrl;
  });
}

/**
 * 复制文本到剪贴板
 * @param {string} text - 要复制的文本
 * @param {HTMLElement} element - 触发复制的元素，用于显示反馈
 */
function copyToClipboard(text, element) {
  if (!text || typeof text !== 'string') {
    console.warn('debugLog: 复制内容无效');
    return;
  }

  // 优先使用 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(function () {
        showCopyFeedback(element, true);
      })
      .catch(function (error) {
        console.warn('复制失败:', error);
        // 降级到 execCommand
        fallbackCopyToClipboard(text, element);
      });
  } else {
    // 降级方案
    fallbackCopyToClipboard(text, element);
  }
}

/**
 * 降级复制方案（使用 execCommand）
 * @param {string} text - 要复制的文本
 * @param {HTMLElement} element - 触发复制的元素
 */
function fallbackCopyToClipboard(text, element) {
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      showCopyFeedback(element, true);
    } else {
      console.warn('复制失败: execCommand 返回 false');
      showCopyFeedback(element, false);
    }
  } catch (error) {
    console.warn('复制失败:', error);
    showCopyFeedback(element, false);
  }
}

/**
 * 显示复制反馈
 * @param {HTMLElement} element - 元素
 * @param {boolean} success - 是否成功
 */
function showCopyFeedback(element, success) {
  if (!element) {
    return;
  }

  const originalBackground = element.style.background;
  const originalTransition = element.style.transition;

  if (success) {
    // 成功：显示淡绿色背景
    element.style.background = '#c8e6c9';
    element.style.transition = 'background 0.3s';
  } else {
    // 失败：显示淡红色背景
    element.style.background = '#ffcdd2';
    element.style.transition = 'background 0.3s';
  }

  // 恢复原背景色
  setTimeout(function () {
    element.style.background = originalBackground;
    setTimeout(function () {
      element.style.transition = originalTransition;
    }, 300);
  }, 500);
}

export default DebugLog;
